import client from './httpClient';

const getUserIdAsHeader = userId => (userId ? { 'X-Uni-User-Id': userId } : {});

export const search = params => client.get('locations_autocomplete', { params }).then(({ data }) => data);

export const offers = (params, experimentId = null, userId = null) => {
  const headers = {
    ...(experimentId ? { 'X-Uni-Experiment-Id': experimentId } : {}),
    ...getUserIdAsHeader(userId)
  };

  return client.get('offers', { params, headers }).then(({ data }) => data);
};

export const residencesOffers = (params, userId = null) => {
  const headers = { ...getUserIdAsHeader(userId) };

  return client.get('residences', { params, headers }).then(({ data }) => data);
};

export const nearbyNeighbourhoodsBySlug = slug => client.get(`neighbourhoods/${slug}/nearby`).then(({ data }) => data);

export const neighbourhoodsFromCityCode = cityCode =>
  client.get(`city/${cityCode}/neighbourhoods`, { limit: 100 }).then(({ data }) => data);

export const nearbyNeighbourhoodsByUniversitySlug = universitySlug =>
  client.get(`neighbourhoods?search_by=nearby_by_university&slug=${universitySlug}`).then(({ data }) => data);

export const similarOffers = params => client.get('recommendations', { params }).then(({ data }) => data);
